import axios from "axios";
import config from "../services/config";
import { clearApplicationCache } from "../utils/cacheUtils";

const Deslogar = (erro, limparCache = true) => {
  console.log('🚪 Logout automático por erro de autenticação...');
  
  // Limpar token
  localStorage.removeItem("token");
  
  // Limpar cache apenas se solicitado (não limpar em erros de login)
  if (limparCache) {
    clearApplicationCache('logout-auto');
    console.log('✅ Cache limpo no logout automático');
  } else {
    console.log('ℹ️ Cache preservado (erro de login)');
  }
  
  console.log('✅ Logout automático concluído');
  
  // Redirecionar para a página de login
  window.location.href = "/login";
};

function pegarToken() {
  return localStorage.getItem("token");
}

const api = axios.create({
  baseURL: config.server.hostname,
  headers: { Authorization: `Bearer ${pegarToken()}` },
});

/*
  Instância para páginas públicas, acessadas por quem NÃO tem conta na plataforma
  (ex.: o responsável em /assinar-contrato, autenticado só pelo token da URL).

  Sem os interceptors de autenticação de propósito: o `api` normal desloga e manda
  para /login em qualquer 404/401/403, e nessas rotas o 404 é resposta legítima
  ("link inválido ou expirado"), que a própria página precisa tratar.
*/
const apiPublico = axios.create({
  baseURL: config.server.hostname,
});

// Instância específica para rotas da Danizinha que precisam de cookies de sessão
const apiDanizinha = axios.create({
  baseURL: config.server.hostname,
  headers: { Authorization: `Bearer ${pegarToken()}` },
  withCredentials: true, // Permite envio de cookies para manter sessão HTTP
});

// Add a response interceptor
api.interceptors.response.use(
  function (response) {
    if (response.data) {
      if (
        response.data.message === "Não autorizado" ||
        response.data.message === "jwt malformed"
      ) {
        // Não interceptar erros de login - deixar a página tratar
        const isLoginError = response.config.url && response.config.url.includes('/login');
        if (!isLoginError) {
          Deslogar(response, true);
        }
      }
    }
    return response;
  },
  function (error) {

    if(error.response && error.response.status === 404) {
      // Verificar se é um erro de correção não encontrada ou rotas específicas
      if (error.config.url && (
        error.config.url.includes('/deletar-correcao/') ||
        error.config.url.includes('/atualizar-correcao') ||
        error.config.url.includes('/correcao-ia/') ||
        error.config.url.includes('/correcao-ia-humano') ||
        error.config.url.includes('/getAllCorrecoes/ia') ||
        error.config.url.includes('/getAtividades/ia') ||
        error.config.url.includes('/redacao/ia') ||
        error.config.url.includes('/getCorrecao/ia')
      )) {
        // Para erros de correção não encontrada ou rotas específicas, não deslogar o usuário
        console.log('Recurso não encontrado, mas não deslogando usuário');
        return Promise.reject(error);
      }
      
      // Não interceptar erros de login - deixar a página tratar
      const isLoginError = error.config.url && error.config.url.includes('/login');
      if (!isLoginError) {
        Deslogar(error, true);
        return false;
      }
    }
    
    // Para outros erros de autenticação
    if(error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Não interceptar erros de login - deixar a página tratar
      const isLoginError = error.config.url && error.config.url.includes('/login');
      if (!isLoginError) {
        Deslogar(error, true);
        return false;
      }
    }

    return Promise.reject(error);
  }
);

api.interceptors.request.use(
  async (config) => {
    const token = pegarToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  }
);

// Interceptors para apiDanizinha (mesma lógica da API principal)
apiDanizinha.interceptors.response.use(
  function (response) {
    if (response.data) {
      if (
        response.data.message === "Não autorizado" ||
        response.data.message === "jwt malformed"
      ) {
        Deslogar();
      }
    }
    return response;
  },
  function (error) {
    if(error.response && error.response.status === 404) {
      if (error.config.url && (
        error.config.url.includes('/deletar-correcao/') ||
        error.config.url.includes('/atualizar-correcao') ||
        error.config.url.includes('/correcao-ia/') ||
        error.config.url.includes('/getAllCorrecoes/ia') ||
        error.config.url.includes('/getAtividades/ia') ||
        error.config.url.includes('/redacao/ia') ||
        error.config.url.includes('/getCorrecao/ia')
      )) {
        console.log('Recurso não encontrado, mas não deslogando usuário');
        return Promise.reject(error);
      }
      
      Deslogar();
      return false;
    }
    
    if(error.response && (error.response.status === 401 || error.response.status === 403)) {
      Deslogar();
      return false;
    }
    
    return Promise.reject(error);
  }
);

apiDanizinha.interceptors.request.use(
  async (config) => {
    const token = pegarToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  }
);

export default api;
export { apiDanizinha, apiPublico };
